// import logger from "redux-logger";
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import rootReducer from "./rootReducer";
import { api } from "@/services/api";

// We no longer need the WebSocket middleware since we're using react-use-websocket directly
const middlewares = [api.middleware];

if (process.env.NODE_ENV === "development") {
  // Toggle this when need to log redux changes.
  // middlewares.push(logger);
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
});

// Wire RTK Query's `setupListeners` so individual endpoints can opt into
// `refetchOnReconnect` / `refetchOnFocus` behaviour. Without this call
// the flags are silently no-ops — the flags dispatch actions that rely
// on listeners registered here. Wiring globally is cheap (one-time
// listener setup) and keeps per-endpoint opt-in the source of truth.
setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;

// Canonical type exports — single source of truth in types.ts
export type { RootState } from "./types";
